import { AssetLoader } from "../../assets/loader";

export async function runPersona(args: string[]) {
  const loader = new AssetLoader();
  const action = args[0] || "list";
  const personaName = args[1];

  switch (action) {
    case "list":
      await listPersonas(loader);
      break;
    case "show":
      if (!personaName) {
        console.error("Usage: metiscode persona show <name>");
        process.exitCode = 1;
        return;
      }
      await showPersona(loader, personaName);
      break;
    case "validate":
      if (!personaName) {
        console.error("Usage: metiscode persona validate <name>");
        process.exitCode = 1;
        return;
      }
      await validatePersona(loader, personaName);
      break;
    default:
      console.log(`
Usage: metiscode persona [action] [name]

Actions:
  list       List available personas (default)
  show       Show persona details
  validate   Validate persona format
`);
  }
}

async function listPersonas(loader: AssetLoader) {
  try {
    const personas = await loader.listPersonas();
    const format = process.env.METIS_FORMAT || "pretty";
    
    if (format === "json") {
      console.log(JSON.stringify(personas, null, 2));
      return;
    }
    
    if (personas.length === 0) {
      console.log("No personas found. Run 'metiscode init' to create the .metis directory.");
      return;
    }
    
    console.log(`Available personas (${personas.length}):`);
    for (const persona of personas) {
      try {
        const p = await loader.loadPersona(persona);
        const isBuiltin = persona === 'default' || persona === 'senior-dev' || persona === 'security-expert';
        const marker = isBuiltin ? "📦" : "📝";
        console.log(`  ${marker} ${p.name} - ${p.description}`);
      } catch (error) {
        console.log(`  ❌ ${persona} - Invalid format`);
      }
    }
    
    console.log(`\nUse: metiscode persona show <name> for details`);
  } catch (error: any) {
    console.error("Error listing personas:", error.message);
    process.exitCode = 1;
  }
}

async function showPersona(loader: AssetLoader, name: string) {
  try {
    const persona = await loader.loadPersona(name);
    const format = process.env.METIS_FORMAT || "pretty";
    
    if (format === "json") {
      console.log(JSON.stringify(persona, null, 2));
      return;
    }
    
    console.log(`Persona: ${persona.name} (v${persona.version})`);
    console.log(`Description: ${persona.description}`);
    
    if (persona.capabilities && persona.capabilities.length > 0) {
      console.log(`Capabilities: ${persona.capabilities.join(", ")}`);
    }
    
    console.log(`Temperature: ${persona.temperature || 0.2}`);
    
    if (persona.model_preferences && persona.model_preferences.length > 0) {
      console.log(`Preferred models: ${persona.model_preferences.join(", ")}`);
    }
    
    console.log("\nSystem Prompt:");
    console.log(persona.system_prompt.split('\n').map(line => `  ${line}`).join('\n'));
    
    if (persona.metadata) {
      console.log("\nMetadata:");
      Object.entries(persona.metadata).forEach(([key, value]) => {
        console.log(`  ${key}: ${JSON.stringify(value)}`);
      });
    }
    
  } catch (error: any) {
    console.error(`Error loading persona '${name}':`, error.message);
    process.exitCode = 1;
  }
}

async function validatePersona(loader: AssetLoader, name: string) {
  try {
    const isValid = await loader.validateAsset('persona', name);
    if (isValid) {
      console.log(`✅ Persona '${name}' is valid`);
    } else {
      console.log(`❌ Persona '${name}' is invalid`);
      process.exitCode = 1;
    }
  } catch (error: any) {
    console.error(`❌ Persona '${name}' validation failed:`, error.message);
    process.exitCode = 1;
  }
}